const embedDocCardI18nDefaults = {
  deleted: 'This linked doc is deleted.',
  emptyPreview: 'Preview of the doc will be displayed here.',
  loadFailed: 'This linked doc failed to load.',
  loading: 'Loading...',
  reload: 'Reload',
  updated: 'Updated',
} as const;

export type EmbedDocCardI18nKey = keyof typeof embedDocCardI18nDefaults;

/** The host app's language for the cards of linked and synced docs: their texts and the locale their
 *  update date is written in. */
export interface EmbedDocCardTranslator {
  translate: (key: EmbedDocCardI18nKey) => string | undefined;
  locale: () => string | undefined;
}

let embedDocCardTranslator: EmbedDocCardTranslator | undefined;

export function registerEmbedDocCardTranslator(
  translator: EmbedDocCardTranslator
): void {
  embedDocCardTranslator = translator;
}

export function embedDocCardI18nT(key: EmbedDocCardI18nKey): string {
  return (
    embedDocCardTranslator?.translate(key) ?? embedDocCardI18nDefaults[key]
  );
}

/** A card's update date in the app's language; the cube card shows the time only. */
export function formatEmbedDocCardDate(date: Date, timeOnly = false): string {
  const locale = embedDocCardTranslator?.locale();
  return timeOnly
    ? date.toLocaleTimeString(locale)
    : date.toLocaleString(locale);
}
